// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"821":"8e69280a","1428":"8e69280a","1615":"5ba0837d","4951":"8e69280a"}[chunkId] + ".chunk.css";
};